import { html, LitElement, css } from "lit";
import { customElement } from "lit/decorators.js";

@customElement('ehm-header')
export class Header extends LitElement {
  static styles = css`
    :host {
      position: sticky;
      top: 0;
      z-index: 1000;
      display: block;
      background: var(--theme-bg);
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 150) {
      document.body.classList.add('compact-header');
    } else if(window.scrollY < 100) {
      document.body.classList.remove('compact-header');
    }
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}